import React, { useContext } from 'react';
import styled from 'styled-components';
import { ClickableContainer, createText } from './mixins';
import { ThemeContext } from 'styled-components';
const Text = (props) => {
    const { children, action } = props;
    const theme = useContext(ThemeContext);
    const Component = styled[props.as || 'p'] `
    ${createText(props, theme)}
  `;
    if (action) {
        return (React.createElement(ClickableContainer, { onClick: action },
            React.createElement(Component, null, children)));
    }
    return React.createElement(Component, null, children);
};
export default Text;
Text.defaultProps = {
    type: 'body',
    fontWeight: 'regular',
};
